import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

export const SmartSection = ({ children }) => (
  <div className="ms-Grid-row">{children}</div>
);

SmartSection.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

const UnStyledSmartGroup = ({
  children,
  colStart,
  colSpan,
  classes,
  totalNodesWithSameLevel,
}) => {
  const defaultBreakpoint = 'xl'; // config will take effect when media width larger than 1024px
  const breakpointsClasses = {
    [`ms-${defaultBreakpoint}Offset${colStart}`]: colStart,
    [`ms-${defaultBreakpoint}${colSpan}`]: colSpan,
    'ms-sm12': !colSpan && totalNodesWithSameLevel === 1,
  };

  return (
    <div className={classNames('ms-Grid-col', breakpointsClasses, classes.customBreakPoint)} style={{ padding: 0 }}>
      <div className={classes.itemContainer}>
        {children}
      </div>
    </div>
  );
};

UnStyledSmartGroup.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  classes: PropTypes.shape({
    itemContainer: PropTypes.string,
  }).isRequired,
  colStart: PropTypes.number,
  colSpan: PropTypes.number,
  totalNodesWithSameLevel: PropTypes.number.isRequired,
};

UnStyledSmartGroup.defaultProps = {
  colStart: undefined,
  colSpan: undefined,
};

export const SmartGroup = withDefaultStyles(UnStyledSmartGroup, (_, { palette = {} }) => ({
  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    background: palette.primaryBackground,
    '& .component-title': {
      color: palette.primaryText,
    },
  },
  customBreakPoint: {
    minHeight: 0,
  },
}));

export const SmartPage = ({ children }) => (
  <div className="ms-Grid" dir="ltr" >
    {children}
  </div>
);

SmartPage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

export const layoutComponentsMapping = {
  page: SmartPage,
  section: SmartSection,
  group: SmartGroup,
};
